var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var AsyncIterator = require('asynciterator');

var MultiTransformIterator = AsyncIterator.MultiTransformIterator;
var SimpleTransformIterator = AsyncIterator.SimpleTransformIterator; // Nested Loop Join, but the values of the inner loop are determined by each value of the outer loop, possibly reducing the number of necessary checks

var DynamicNestedLoopJoin =
/*#__PURE__*/
function (_MultiTransformIterat) {
  "use strict";

  _inherits(DynamicNestedLoopJoin, _MultiTransformIterat);

  function DynamicNestedLoopJoin(left, funRight, funJoin) {
    var _this;

    _classCallCheck(this, DynamicNestedLoopJoin);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DynamicNestedLoopJoin).call(this, left));
    _this.funRight = funRight;
    _this.funJoin = funJoin;
    return _this;
  }

  _createClass(DynamicNestedLoopJoin, [{
    key: "_createTransformer",
    value: function _createTransformer(leftItem) {
      var _this2 = this;

      return new SimpleTransformIterator(this.funRight(leftItem), {
        transform: function transform(rightItem, done) {
          var result = _this2.funJoin(leftItem, rightItem);

          if (result !== null) _this2._push(result);
          done();
        }
      });
    }
  }]);

  return DynamicNestedLoopJoin;
}(MultiTransformIterator);

module.exports = DynamicNestedLoopJoin;